import React from 'react'

import {
  CheckBox,
  Span,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Copy
} from 'components'
import {
  ContratosResponsePesquisaMovimentacao,
  GetPesquisaAnalista,
  ITipeAction
} from 'pages/Supplier/MovMensal/types'
import { COLORS, SPACING } from 'utils'
export interface ITablePesquisaMov {
  tableData: GetPesquisaAnalista[]
  handleAddNewTab: (
    _competencia: string,
    _tipo: ITipeAction,
    _data: ContratosResponsePesquisaMovimentacao | GetPesquisaAnalista
  ) => void
  handleChangeRowsPerPage: (
    _event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  handleChangePage: (_newPage: number) => void
  rowsPerPage: number
  page: number
  pageCount: number
  setListaPesquisa: (newArray: Array<any>) => void
}
const TablePesquisaMov: React.FC<ITablePesquisaMov> = ({
  tableData,
  handleAddNewTab,
  handleChangeRowsPerPage,
  handleChangePage,
  page,
  rowsPerPage,
  pageCount,
  setListaPesquisa
}: ITablePesquisaMov) => {
  const objMob = {
    '0': 'Sem Mobilização',
    '1': 'Com Mobilização',
    '2': 'Somente Compartilhado'
  }

  const movList = () => {
    return tableData?.map((el) => (
      <TableRowStyled key={el.movimentacaoId}>
        <TableCellStyled align="left">
          <Copy valueToCopy={el.cdContrato} title="Copiar código de contrato" />
        </TableCellStyled>
        <TableCellStyled
          onClick={() =>
            handleAddNewTab(
              el.mesAno.toString(),
              el.flCompAtual ? 'New' : 'Old',
              el
            )
          }
        >
          <Span
            text={el.cdContrato.toString() || '- - - - -'}
            color={COLORS.blueFonts}
            fontSize="13px"
            fontWeight="700"
            cursor="pointer"
          />
        </TableCellStyled>
        <TableCellStyled align="center" style={{ paddingRight: SPACING.spacing50 }}>
          {`${el.mesAno.toString().slice(4) + '/' + el.mesAno.toString().slice(0, 4)}` || '- - - - -'}
        </TableCellStyled>
        <TableCellStyled> {el.nmFornecedor || '- - - - -'}</TableCellStyled>
        <TableCellStyled align='center'> {objMob[el.flStatusMobilizacao] || '- - - - -'}</TableCellStyled>
        <TableCellStyled style={{ textAlign: 'center' }}> {el?.totalEfetivo || '0'}</TableCellStyled>
        <TableCellStyled align="center"> <CheckBox checked={el.flContraparte} /> </TableCellStyled>
        <TableCellStyled align="center"> <CheckBox checked={el.flAnalista} /> </TableCellStyled>
      </TableRowStyled>
    ))
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="center" style={{ paddingRight: SPACING.spacing50 }}>Competência</TableCellStyled>
              <TableCellStyled align="left">Fornecedor</TableCellStyled>
              <TableCellStyled align="center">Status Mobilização</TableCellStyled>
              <TableCellStyled align="center">Total Efetivo</TableCellStyled>
              <TableCellStyled align="center">Validação Contraparte</TableCellStyled>
              <TableCellStyled align="center">Validação Analista</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled >
            {tableData?.length > 0 && movList()}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page || 1}
        rows={tableData}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        typeFooter="online"
        handleChangePage={(newPage) => {
          setListaPesquisa([])
          handleChangePage(newPage)
        }}
        handleChangeRowsPerPage={(event) => {
          setListaPesquisa([])
          handleChangeRowsPerPage(event)
        }}
      />
    </>
  )
}

export default TablePesquisaMov
